import { render, staticRenderFns } from "./BookSort.vue?vue&type=template&id=7bb31182&"
import script from "./BookSort.vue?vue&type=script&lang=js&"
export * from "./BookSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports